module.exports = __webpack_public_path__ + "img/south_ossetia.aa12aecc.svg";